import { FC, ReactNode } from 'react'
import {
  Checkbox as MuiCheckbox,
  CheckboxProps as MuiCheckboxProps,
  FormControlLabel,
} from '@mui/material'
import classNames from 'classnames'

import { Text } from '../Text'

import './index.scss'

interface CheckboxProps extends MuiCheckboxProps {
  dashed?: boolean
  editable?: boolean
  label?: ReactNode
}

export const Checkbox = ({
  className,
  dashed,
  editable = true,
  label,
  ...props
}: CheckboxProps) => {
  if (!editable) return <Uneditable checked={props.checked} className={className} label={label} />

  return (
    <FormControlLabel
      className={classNames('populus-checkbox', dashed && 'dashed', className)}
      control={<MuiCheckbox indeterminate={dashed} {...props} />}
      label={label}
    />
  )
}

const Uneditable: FC<CheckboxProps> = ({ checked, className, label }) => {
  return (
    <div className={classNames('populus-checkbox-uneditable', className)}>
      <div className={classNames('checkbox-container', checked && 'checked')}></div>
      <Text className={classNames('checkbox-text', !checked && 'unchecked')} styleType="body">
        {label?.toString()}
      </Text>
    </div>
  )
}
